<template>
    <div class="notice_ul">
        <div class="content">
          <ul>
            <li class="main">
              <router-link to="notice">征集大赛公告</router-link>
            </li>
            <li>
              <router-link to="notice">短视频规则</router-link>
            </li>
            <li>
              <router-link to="notice">图片故事规则</router-link>
            </li>
          </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'noticelist',
    data: function () {
        return {
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.notice_ul {
    width: 1200px;
    margin: 50px auto;
    text-align: center;
    font-size: 20px;
    text-align: left;
    .content {
      width: 1200px;
      padding: 31px 51px;
      background-color: rgba(#fff, 0.8);
      ul {
        list-style-type: disc;
        li {
          margin: 15px 0;
          color: #0b2ab0;
        }
        .main {
          text-decoration: underline;
          font-weight: bold;
        }
      }
    }
}
</style>
